import React, { useState } from 'react';
import Router from './routes/Router';
import useRoutes from './routes/useRoutes';
import { RouteProps } from 'react-router-dom';

const App: React.FC = () => {
    const [allRoutes] = useState(useRoutes());

    return <Router allRoutes={Array.from(allRoutes) as RouteProps[]} />;
};

export default App;
